<template>
    <modal :open="localOpen" size="lg" @close="$emit('close')" borderColor="primary" :borderSize="1">
        <template #default>
        
            <alert v-if="error">
                {{ error }}
                <ui-button class="ms-3" @click="requestData">
                    Try Again
                </ui-button>
            </alert>
            <template v-if="profile">

                <ai-profile-summary v-if="profile.verified" :profile="profile" @refresh="requestFresh" style="margin-top:-35px;" />
                <div v-else  class="text-center" style="margin-top:-35px;">
                    <h1>Your Aesthetic Profile</h1>
                    <p>We sent a link to your profile to the email and phone provided.</p>
                    <p>If you haven't received the email, please check your spam folder.</p>
                </div>
            </template>
            <div v-else-if="!error" class="text-center" style="margin-top:-35px;">
                <h1 class="mb-3">Your Aesthetic Profile</h1>
                <transition name="v-slide-transition-1">
                    <h4 v-if="loadingIndex == 0">{{ loadingMessages[0] }}</h4>
                    <h4 v-else-if="loadingIndex == 1">{{ loadingMessages[1] }}</h4>
                    <h4 v-else-if="loadingIndex == 2">{{ loadingMessages[2] }}</h4>
                    <h4 v-else-if="loadingIndex > 2">{{ loadingMessages[3] }}</h4>
                </transition>
                <div class="text-center p-5">
                    <spinner/>
                </div>
            </div>
        </template>
        <template v-if="profile" #buttons>
            <ui-button @click="localOpen=false" class="mx-auto">
                See All Recommended Properties
            </ui-button>
        </template>
    </modal>
</template>
<script type="text/javascript">
    import AiProfileSummary from '@/components/Content/Travelers/AI/Summary.vue';
    import CommonComponents from '@/components/Common.vue';

    import ApiConfig from '@/config/api.json';

    import { UseApiStore } from '@/store/Api.js';

    export default {
        components: {
            AiProfileSummary,
            ...CommonComponents,
        },

        setup() {
            return {
                apiStore: UseApiStore(),
            };
        },

        data() {
            return {
                disposed: false,

                error: null,
                requestsTimer: null,

                loadingIndex: -1,
                loadingMessages: ["Identifying design elements...", "Checking furniture and decor...", "Checking structural features...", "Generating profile..."],
                loadingMessagesTimer: null,

                localOpen: true,
            };
        },

        props: {
            id: {
                type: [Number, String],
                required: true,
            },

            hash: {
                type: String,
                required: true,
            },

            open: {
                type: Boolean,
                default: true,
            },
        },

        emits: ['close', 'profile'],

        created() {
            this.requestData();
            this.loadingMessagesTimer = setTimeout(this.startLoadingMessages, 500);

            this.localOpen = this.open;
        },

        beforeUnmount() {
            
            this.disposed = true;
            clearTimeout(this.requestsTimer);
            clearTimeout(this.loadingMessagesTimer);
        },

        watch: {
            open() {
                this.localOpen = this.open;
            },
        },

        computed: {

            requestUrl() {
                let re = 'ai/profile/'+this.id+'/view/'+this.hash;
                return re;
            },

            profile() {
                let response = this.apiStore.requests[this.requestUrl];

                if (!response) {
                    return null;
                }

                if ((response.valid) && (response.results) && (!response.results.error)) {
                    this.emitProfile();
                    return response.results;
                }
                else {
                    let error = 'Could not complete request';
                    if ((response.results) && (response.results.error)) {
                        if (response.results.error.message) error = response.results.error.message;
                        else error = response.results.error;
                    }
                    this.setError(error);
                }
                
                return null;
            },
        },

        methods: {

            startLoadingMessages() {
                if (this.disposed) return;

                this.loadingIndex++;
                if (this.loadingIndex >= this.loadingMessages.length) {
                    return;
                }
                clearTimeout(this.loadingMessagesTimer);
                this.loadingMessagesTimer = setTimeout(this.startLoadingMessages, 1000);
            },

            requestFresh() {
                this.requestData(true);
            },

            async requestData(fresh) {
                if (this.disposed) return;
                
                this.setError(null);
                
                clearTimeout(this.requestsTimer);

                let payload = {
                    url: this.requestUrl,
                };

                if (fresh) {
                    payload.fresh = true;
                }

                await this.apiStore.get(payload);

                this.requestsTimer = setTimeout(this.requestData, ApiConfig.dashboardCache * 1000);
            },

            setError(error) {
                this.error = error;
            },

            emitProfile() {
                setTimeout(function() {
                    this.$emit('profile', this.profile);
                }.bind(this), 125);
            },
        }
    }
</script>